import { render, staticRenderFns } from "./VsTerms.vue?vue&type=template&id=3f2fa8bc&"
import script from "./VsTerms.vue?vue&type=script&lang=js&"
export * from "./VsTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports